/**
 * Directive: spectrum
 */
angular.module('acme.common.directive.spectrum', [
  'acme.common.service.helpers'
])
.directive('spectrum', ['HelpersService', '$timeout', function(HelpersService, $timeout) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/spectrum/spectrum.tpl.html',
      scope: {
        name: '@',
        help: '@',
        config: '=?',
        colors: '=',
        showHelp: '@',
        position: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $timeout(function() {
          var el = $("#" + $scope.name);

          // Don't initialize if it does not exist
          if (typeof(el.spectrum) !== 'function') { return; }

          el.spectrum($scope.spectrum.config);

          if (typeof(el.spectrum('get').toHexString) === 'function') {
            $scope.colors = {
              textColor: HelpersService.getContrastYIQ(el.spectrum('get').toHexString()),
              backgroundColor: el.spectrum('get').toHexString()
            };
          }

          $scope.$on('$destroy', function() {
            el.spectrum('destroy');
          });

        }, 0);
      },

      controller: ['$scope', function($scope) {

        $scope.spectrum = {

          help: $scope.help || 'Backoffice calendar and list color. \n ACME colors are WCAG AA compliant.',
          config: {},
          tooltipPosition: $scope.position || 'right',
          colorPallete: [
            "#B91913",
            "#AF0D56",
            "#3E4EB8",
            "#1194F6",
            "#0C74D5",
            "#00BCD6",
            "#0544A4",
            "#008390",
            "#19A79A",
            "#00695C",
            "#47B04B",
            "#2A7E2E",
            "#89C540",
            "#CDDE20",
            "#FFED18",
            "#FF9900",
            "#FF5607",
            "#FF504D",
            "#9D1BB2",
            "#6734BA",
            "#7A5547",
            "#424242",
            "#9E9E9E",
            "#5F7D8C",
            "#EC7BFF",
            "#B384FF",
            "#FBE5FF",
            "#D1C3EA",
            "#E7372D",
            "#EC1561",
            "#FF7EAB",
            "#80AFFF",
            "#7CD7FF",
            "#7EFFFF",
            "#A4FFEB",
            "#B7F7C9",
            "#CBFF8A",
            "#D2E049",
            "#FFFF85",
            "#FFE677",
            "#FF9E7C",
            "#E0E0E0"
          ],

          init: function() {

            var color = '#000000';

            $scope.$on('$destroy', $scope.$watch('config.color', this.onConfigColorUpdate));

            this.config = angular.extend({}, {
              color: color,
              theme: 'sp-acme',
              flat: false,
              showInput: true,
              showInitial: true,
              allowEmpty: true,
              showAlpha: false,
              showPalette: true,
              togglePaletteOnly: false,
              showSelectionPalette: false,
              clickoutFiresChange: true,
              hideAfterPaletteSelect:true,
              titleText: "",
              pickerHeading: "Custom",
              paletteHeading: "ADA Compliant",
              preferredFormat: "hex",
              chooseText: "Select Color",
              palette: this.chunkPalette(),
              change: function(color) {

                $scope.colors = {
                  textColor: HelpersService.getContrastYIQ(color.toHexString()),
                  backgroundColor: color.toHexString()
                };

                $scope.$apply();

              }
            }, $scope.config);

          },

          chunkPalette: function() {
            var i, ii,
                j = -1,
                chunks = [],
                chunkLength = 5;

            for (i=0,ii=this.colorPallete.length;i<ii;i++) {
              if (i%chunkLength === 0) {
                chunks[++j] = [];
              }
              chunks[j][i%chunkLength] = this.colorPallete[i];
            }

            return chunks;

          },

          onConfigColorUpdate: function(n, o) {
            if (n && n !== o) {
              $scope.spectrum.config.color = n;
              var el = $("#" + $scope.name);

              // Don't initialize if it does not exist
              if (typeof(el.spectrum) !== 'function') { return; }

              el.spectrum('set', $scope.spectrum.config.color);
            }
          }

        };

        $scope.spectrum.init();

      }]

    };

}]);